import { variantsRotate, MotionIconWrapper } from '@comeon/ui';

import Icon, { ICON_BOTTOM } from '~/components/icon/index.js';

import { getAccountInfo, getLogo } from '~/components/payment/quick-deposit-beta/utils/qd-helpers';
import { LOADING } from '~/components/payment/quick-deposit-beta/utils/constants';
import {
	MoreMethodsLink,
	MethodsCollapse,
	MethodsCollapseTitle
} from '~/components/payment/quick-deposit-beta/utils/qd-styled-utils';

const motionTransitionSettings = {
	x: { type: 'spring', stiffness: 100, damping: 100 }
};

const QDMethodsCollapse = ({
	views,
	depositInfo,
	selectedMethod,
	translations: t,
	methodListToggle,
	toggleMethodList,
	selectMethodAndExecute,
	onMoreMethodsClick
}) => {
	const numberOfMethods = depositInfo?.instantDepositInfoForMethods.length;
	const showMethodsSelection = numberOfMethods > 1;

	return showMethodsSelection ? (
		<>
			<MethodsCollapseTitle
				data-at="qd-change-method-title"
				disabled={views.includes(LOADING)}
				onClick={() => toggleMethodList(!methodListToggle)}
				className="button u-pt0"
			>
				<span>{t.CHANGE_PAYMENT_METHOD_LIST}</span>
				<MotionIconWrapper
					initial="down"
					variants={variantsRotate}
					animate={methodListToggle ? 'up' : 'down'}
					transition={motionTransitionSettings}
					className="icon-wrapper"
				>
					<Icon type={ICON_BOTTOM} />
				</MotionIconWrapper>
			</MethodsCollapseTitle>
			<MethodsCollapse toggle={methodListToggle} items={numberOfMethods}>
				<ul className="link-list u-mt0">
					{depositInfo?.instantDepositInfoForMethods?.map(provider =>
						selectedMethod?.depositMethodId !== provider.depositMethodId ? (
							<li
								key={provider.paymentMethodNameTextKey}
								className="link-list__item-link"
								onClick={() => selectMethodAndExecute(provider)}
								aria-hidden="true"
								data-at={`${provider.paymentMethodNameTextKey}-paymentmethod-quick-deposit`}
							>
								{getLogo(provider)}
								<span className="u-text-l u-flex u-no-break payment-method-qd-cc-nr">
									{getAccountInfo(provider) || t[provider.paymentMethodNameTextKey]}
								</span>
							</li>
						) : null
					)}
					<MoreMethodsLink className="link-list__item-link" onClick={onMoreMethodsClick}>
						<span className="u-text-l">{t.QD_MORE_METHODS}</span>
					</MoreMethodsLink>
				</ul>
			</MethodsCollapse>
		</>
	) : (
		<MethodsCollapseTitle
			data-at="qd-change-method-title"
			disabled={views.includes(LOADING)}
			onClick={onMoreMethodsClick}
			className="button u-pt0"
		>
			<span>{t.CHANGE_PAYMENT_METHOD_LIST}</span>
		</MethodsCollapseTitle>
	);
};

export default QDMethodsCollapse;
